// extracted by mini-css-extract-plugin
export default {"li":"row-module__li__+0vqS","bonusModule":"row-module__bonusModule__JTzHZ","ribbon":"row-module__ribbon__1Bi1H","tnc":"row-module__tnc__f+D-F"};